module.exports = __webpack_public_path__ + "img/jiao.2379b827.png";